<template>
  <EmptyState :title="$t('couldNotLoadContent')" :icon="['fal', 'exclamation-circle']">
    <template #actions>
      <ButtonComponent :label="$t('retry')" :icon="['fal', 'sync-alt']" @click="$emit('retry')" />
    </template>
  </EmptyState>
</template>

<script>
import EmptyState from '@/components/EmptyState'
import { ButtonComponent } from 'vue-elder-button'

export default {
  components: {
    EmptyState,
    ButtonComponent,
  },
}
</script>
